import { Component, OnInit, inject } from '@angular/core';

import { RouterLink, ActivatedRoute } from '@angular/router';
import { QrStateService } from '../services/qr-state.service';

@Component({
  selector: 'app-payment-cancel',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main class="min-h-screen bg-gray-950 text-gray-100 flex items-center justify-center px-4">
      <div class="w-full max-w-md">
        <div class="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-500 via-orange-400 to-amber-400 p-8 text-gray-950 shadow-2xl">
          <div class="flex flex-col items-center text-center">
            <div class="mb-6 grid h-20 w-20 place-items-center rounded-full bg-white/30 text-5xl"></div>

            <h1 class="text-3xl font-bold mb-3">Zahlung abgebrochen</h1>
            <p class="text-lg text-gray-900/90 mb-2">
              Du hast die Zahlung abgebrochen.
            </p>
            <p class="text-sm text-gray-900/80">
              Keine Sorge, es wurde nichts berechnet.
            </p>
          </div>
        </div>

        <!-- Info Box -->
        <div class="mt-6 rounded-xl border border-gray-800 bg-gray-900 p-6">
          <h2 class="text-lg font-semibold mb-3">Was möchtest du tun?</h2>
          <ul class="space-y-2 text-sm text-gray-400">
            <li class="flex items-start gap-2">
              <span class="text-orange-500 material-symbols-outlined">arrow_forward</span>
              <span>Deine Artikel bleiben im Warenkorb gespeichert</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-orange-500 material-symbols-outlined">arrow_forward</span>
              <span>Du kannst die Zahlung jederzeit erneut versuchen</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-orange-500 material-symbols-outlined">arrow_forward</span>
              <span>Oder du kannst deine Bestellung anpassen</span>
            </li>
          </ul>
        </div>

        <div class="mt-6 flex flex-col gap-3">
          <a
            routerLink="/checkout"
            class="w-full inline-flex items-center justify-center rounded-xl bg-orange-500 px-6 py-3 text-base font-medium text-white transition hover:bg-orange-400"
          >
            Zurück zur Kasse
          </a>

          <a
            routerLink="/"
            class="w-full inline-flex items-center justify-center rounded-xl border border-gray-700 bg-gray-900 px-6 py-3 text-base font-medium text-gray-300 transition hover:bg-gray-800"
          >
            Zur Speisekarte
          </a>
        </div>

        <div class="mt-6 rounded-xl border border-gray-800 bg-gray-900 p-4 text-center">
          <p class="text-sm text-gray-400">
            Probleme mit der Zahlung?
          </p>
          <p class="text-xs text-gray-500 mt-1">
            Wende dich bitte an das Personal für alternative Zahlungsmöglichkeiten.
          </p>
        </div>
      </div>
    </main>
  `,
})
export class PaymentCancelComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private qrState = inject(QrStateService);

  ngOnInit() {
    this.qrState.initializeFromUrl(this.route);
  }
}
